import PromoTileWrapper from "../PromoTileWrapper";
import PropTypes from "prop-types";
import {
  FLOOR_MEN,
  FLOOR_WOMEN
} from "../../../../../state/modules/config/constants";
import styles from "./PromoTile.css";

const config = {
  COM: {
    translations: {
      brands_at_asos: "Brands @ ASOS",
      copy:
        "Shop the latest from our 850+ brands @ ASOS now. Including ASOS Design, Nike & adidas.",
      shop_now: "SHOP NOW"
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/men/ctas/mens-email-6/cat/?cid=17625#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/women/ctas/womens-email-3/cat/?cid=17540#ctaref-plp-tile"
    }
  },
  US: {
    translations: {
      brands_at_asos: "Brands @ ASOS",
      copy:
        "Shop the latest from our 850+ brands @ ASOS now. Including ASOS Design, Nike & adidas.",
      shop_now: "SHOP NOW"
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/us/men/ctas/mens-email-6/cat/?cid=17625#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/us/women/ctas/womens-email-3/cat/?cid=17540#ctaref-plp-tile"
    }
  },
  FR: {
    translations: {
      brands_at_asos: "Marques ASOS",
      copy:
        "Shoppe les nouveautés de + de 850 marques sur ASOS. Avec ASOS DESIGN, Nike et adidas.",
      shop_now: "SHOPPER"
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/fr/homme/ctas/e-mail-homme-6/cat/?cid=17625#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/fr/femme/ctas/e-mail-femme-3/cat/?cid=17540#ctaref-plp-tile"
    }
  },
  DE: {
    translations: {
      brands_at_asos: "Brands @ ASOS",
      copy:
        "Hol dir die neuesten Styles von über 850 Marken @ ASOS – darunter ASOS Design, Nike & adidas!",
      shop_now: "JETZT SHOPPEN"
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/de/herren/ctas/herren-e-mail-6/cat/?cid=17625#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/de/damen/ctas/damen-e-mail-3/cat/?cid=17540#ctaref-plp-tile"
    }
  }
};

const PromoTile = ({ storeCode, floor }) => {
  const {
    translations: { brands_at_asos, copy, shop_now },
    FLOOR_TO_URL_MAPPING
  } = config[storeCode];
  const linkUrl = FLOOR_TO_URL_MAPPING[floor];

  return (
    <PromoTileWrapper linkUrl={linkUrl}>
      <div className={styles.promoTile}>
        <div className={styles.brands_at_asos}>{brands_at_asos}</div>
        <div className={styles.copy}>{copy}</div>
        <div className={styles.shop_now_wrapper}>
          <div className={styles.shop_now}>{shop_now}</div>
        </div>
      </div>
    </PromoTileWrapper>
  );
};

PromoTile.propTypes = {
  storeCode: PropTypes.string.isRequired,
  floor: PropTypes.string.isRequired
};

export default PromoTile;
